export default function () {
    let timer = null;

    return function (callback, interval = 500) {
        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(() => {
            callback();
        }, interval);
    };
}
